import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterDashboardFooterLink } from '../../types';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardFooterLink>) => void;
  filter: Partial<FilterDashboardFooterLink>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { valid } = filter;

  function setDisplayInvalidFooterLink(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      valid: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <AntdCheckbox checked={!valid} onChange={setDisplayInvalidFooterLink}>
        Afficher les liens inactifs
      </AntdCheckbox>
    </div>
  );
}
